import { PLATFORM_BASE } from '@constants/Defaults';
import { isProduction } from '@lib/utils';
import { app } from '@packages/app';
import { NotificationServiceProvider } from '@packages/notifications';
import { ReduxServiceProvider } from '@redux-src/ReduxServiceProvider';
import { createBrowserHistory } from 'history';
import { Action, applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Reducers } from './reducers';
import rootSaga from './saga';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers =
    !isProduction() && window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']
        ? window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']
        : compose;

export const history = typeof window !== 'undefined' ? createBrowserHistory({ basename: PLATFORM_BASE + '/' }) : null;

export const store = createStore<any, Action, Record<string, any>, Record<string, any>>(
    combineReducers(Reducers) as any,
    composeEnhancers(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(rootSaga, { notify: app(NotificationServiceProvider) });

// store service
const reduxService: ReduxServiceProvider = app(ReduxServiceProvider);
reduxService.setStore(store);

if (typeof window !== 'undefined' && window['__HSL__'] && history) {
    history.listen((location, method) => {
        if (typeof window !== 'undefined') {
            const changeEvent = new Event('routerChange');
            const resizeEvent = new Event('resize');

            changeEvent['data'] = { location, method };
            resizeEvent['data'] = { skipDrawer: true };

            window.dispatchEvent(resizeEvent);
            window.dispatchEvent(changeEvent);
        }
    });
    window['__HSL__'] = true;
}
